/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AnalyticsIds} from '@ion/core/src/analytics/types';
import {AssetTypeFilter} from '@ion/dls/src/filters/AssetTypeFilter';
import {Filters} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

interface TypesFilterParamsType extends FilterParamsType {}

export const TypesFilter = ({
  isPhone,
  globalGroupId,
  toggleView,
  filterState,
  handleSubmit
}: TypesFilterParamsType) => (
  <AssetTypeFilter isMobileView={isPhone}
    elementId={AnalyticsIds.assetHistoryTypeFilter}
    name={Filters.assetTypes}
    accountId={globalGroupId}
    onCancel={toggleView}
    onMenuClose={toggleView}
    filterState={filterState[Filters.assetTypes]}
    onSubmit={handleSubmit} />
);
